// VH-206: the review filter's backlog — captured entries with no machine.
import { useQuery } from '@tanstack/react-query'
import { weeklyProgramsAPI } from '../services/api'

export const UNATTRIBUTED_QUERY_KEY = ['session-exercises', 'unattributed']

export function useUnattributedExercises() {
  return useQuery({
    queryKey: UNATTRIBUTED_QUERY_KEY,
    queryFn: () => weeklyProgramsAPI.getUnattributedExercises(100).then((r) => r.data),
  })
}
